import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpHandlingService } from 'src/app/api/services/http-handling.service';
import { ConfirmationDialogContent } from '../../types/confirmation-dialog.interface';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

  message: string | null = null;
  url: string | null = null;
  buttonText: string | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) private data: ConfirmationDialogContent, private http: HttpClient, private httpHandlingService: HttpHandlingService,
              private dialogRef: MatDialogRef<ConfirmationDialogComponent>) {}

  ngOnInit(): void {
    this.message = this.data.message;
    this.url = this.data.url;
    this.buttonText = this.data.buttonText;
  }

  execute(): void {
    this.http.delete<void>(this.url, {headers: this.httpHandlingService.authorizationHeaders()}).subscribe(() => {
      this.dialogRef.close(true);
    },
    (error: HttpErrorResponse) => alert(error.message));
  }
}
